// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XQ1K","col":"styles_col__17m1Q"};